export default "__VITE_ASSET__QiKBw$JM__"